const dotenv = require('dotenv').config();
module.exports = {
    front: {
        environment: process.env.REACT_APP_ENVIRONMENT || "local",
        api_url: process.env.REACT_APP_API_URL,
        react_app_test: process.env.REACT_APP_TEST
    }
}
